var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-row',{attrs:{"gutter":30}},[_c('a-col',{attrs:{"span":12}},[_c('ranking-take-count')],1),_c('a-col',{attrs:{"span":12}},[_c('ranking-views')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }